import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const dashboard = 'board/validation-member';
const company = 'company/validation-member';
const matrix = 'matrix/validation-member';
export const apiGetValidationDashboard = async (val) => {
  const dashboard__ = await http.post(`${URL + dashboard}`, val);
  dashboard__.data.data.type = 'dashboard';
  return dashboard__?.data?.data || false;
};
export const apiGetValidationCompany = async (val) => {
  const data = await http.post(`${URL + company}`, val);
  data.data.data.type = 'company';
  return data?.data?.data || false;
};
export const apiGetValidationMatrix = async (val) => {
  const data = await http.post(`${URL + matrix}`, val);
  data.data.data.type = 'matrix';
  return data?.data?.data || false;
};
